import gql from 'graphql-tag';

export const COPY_TEMPLATE = gql`
  mutation CopyTemplateAndCloseReasons($input: CopyBusinessProcessFlowTemplateInput!) {
    bpf {
      copyTemplateAndCloseReasons(input: $input) {
        businessProcessFlowId
      }
    }
  }
`;
